import { Box, Grid, Typography } from "@mui/material";
import React from "react";

const VideosComponent = ({ videos }) => {
  return (
    <>
      <Box className={"videos"}>
        {videos.map((data, index) => (
          <Box key={index} minHeight={160} className={"videoItem"}>
            <video
              src={data.video_link}
              alt={data.title}
              // height={50}
              // width={50}
              controls={true}
            />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default VideosComponent;
